var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, onMounted, watchEffect } from "vue";
import { storeToRefs } from "pinia";
import localize from "@/utils/localization";
import { useUserStore } from "@/stores/userStore";
import { useHistoryStore } from "@/stores/historyStore";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import LoadingSpan from "@/components/LoadingSpan.vue";
import MultipleViewList from "./MultipleViewList.vue";
import SelectorModal from "@/components/History/Modals/SelectorModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleView',
    setup(__props) {
        const filter = ref("");
        const showSelectModal = ref(false);
        library.add(faTimes);
        const { currentUser } = storeToRefs(useUserStore());
        const { histories, currentHistory } = storeToRefs(useHistoryStore());
        const historyStore = useHistoryStore();
        const selectedHistories = computed(() => historyStore.pinnedHistories);
        const noHistoriesInView = computed(() => !selectedHistories.value.length && histories.value.length > 0);
        const loadingPinnedHistories = ref(true);
        const stopStoreWatcher = ref(null);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            loadingPinnedHistories.value = true;
            stopStoreWatcher.value = watchEffect(() => {
                if (noHistoriesInView.value == true) {
                    historyStore.pinHistory(histories.value[0].id);
                    if (stopStoreWatcher.value) {
                        stopStoreWatcher.value();
                    }
                }
            });
            loadingPinnedHistories.value = false;
        }));
        /**
         * From the incoming list, pin histories that are not already pinned and
         * unpin histories that are not in the incoming list.
         * This is a mechanism to allow users to select or deselect histories in modal.
         * @param histories the incoming list of histories to pin
         */
        function addHistoriesToList(histories) {
            // Unpin histories that are already pinned but not in the incoming list
            const historiesToUnpin = selectedHistories.value.filter((pinnedHistory) => !histories.some((history) => history.id === pinnedHistory.id));
            historiesToUnpin.forEach((history) => {
                historyStore.unpinHistory(history.id);
            });
            // Pin histories that aren't already pinned and are in incoming list
            histories.forEach((history) => {
                const historyExists = selectedHistories.value.some((h) => h.id === history.id);
                if (!historyExists) {
                    historyStore.pinHistory(history.id);
                    historyStore.loadHistoryById(history.id);
                }
            });
        }
        function updateFilter(newFilter) {
            filter.value = newFilter;
        }
        return { __sfc: true, filter, showSelectModal, currentUser, histories, currentHistory, historyStore, selectedHistories, noHistoriesInView, loadingPinnedHistories, stopStoreWatcher, addHistoriesToList, updateFilter, localize, FontAwesomeIcon, LoadingSpan, MultipleViewList, SelectorModal };
    }
});
